
const Subtitle = props => {
    return (
        <h3 className="mb-4 text-center">{props.text}</h3>
    ) 
}

export default Subtitle;
